import Config from '@/config'
import Utils from '@/utils'
import BackdoorApi from '@/api/backdoor'

// Whitelabel is only a customer-branded domain over the same account, so a backdoor on our own
// presenter shows the same data — and the grant cookie is host-only, so a customer domain could never
// carry it anyway.
const openPresenterAs = async (userId) => {
  let started = false

  try {
    const body = await BackdoorApi.startBackdoor(userId)
    started = Boolean(body && body.success)
  } catch (error) {
    started = false
  }

  if (!started) {
    Utils.showToastError('Could not start a backdoor session. Try again, or use a different browser.')
    return
  }

  window.open(`${Config.presenterUrl}/?admin=true`, '_blank', 'noopener')
}

export default { openPresenterAs }
